
<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count= 'count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem labelString="商品" v-model="query.nameMix" ></goodsSearchItem>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>

      <div slot="table">
        <div class="btns">
          <DownloadButton  @on-click="handleExport" v-if="handlePermission('drugDullExport')" ></DownloadButton>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import reportService from '@/services/report';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'drugDull',
  mixins: [mapState, queryMixins],
  data() {
    return {
      disablePage: false,
      params: {
        storeIdList: [], // 门店id
        nameMix: '', // 商品名称
      },
      query: {
        storeIdList: [], // 门店id
        nameMix: '', // 商品名称
      },
      columns: [
        { title: '序号', type: 'index', width: 70 },
        { title: '门店', key: 'storeName', minWidth: 116 },
        { title: '商品编码', key: 'serialCode', minWidth: 60 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 60 },
        { title: '规格', key: 'spec', minWidth: 60 },
        { title: '生产企业', key: 'producer', minWidth: 116 },
        { title: '单位', key: 'unit', width: 60 },
        { title: '库存数量', key: 'inventoryNum', minWidth: 50 },
        { title: '库存成本', key: 'inventoryAmount', minWidth: 70 },
        { title: '最后销售日期', key: 'lastSaleTimeStr', minWidth: 90 },
        { title: '不动销天数', key: 'noSaleNum', minWidth: 90 },
        {
          title: '最近有效期时间',
          key: 'expiryDate',
          minWidth: 90,
          render: (h, { row }) => h('span', utils.exchangeTime(row.expiryDate)),
        },

        { title: '最近有效期数量', key: 'lastExpiryNum', minWidth: 90 },
      ],
      tableData: [],
    };
  },
  methods: {
    handleExport() { // 导出
      const temp = utils.deepClone(this.params);
      delete temp.page;
      delete temp.size;
      temp.queryCondition = utils.getQueryCondition('.queryContainer');
      reportService.unsaleListExport(temp).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      reportService.unsaleList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.tableData.push(result);
          });
          console.log(res.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        storeIdList: [],
        nameMix: '',
      };
    },
  },
  mounted() {
    this.handleSearch(true);
    if (this.roleType !== 2) {
      // this.columns.splice(0, 0, { title: '门店名称', key: 'saleRecallPlanStoreName', minWidth: 116 });
    }
  },
  components: {
    QueryFrame,
    DownloadButton,
  },
};
</script>

<style scoped>
  .btns{
    margin-bottom: 12px
  }
</style>
